import { createSlice } from '@reduxjs/toolkit';
import { add, set } from 'lodash';


const initialState = {
    activeCampusId: 1,
    activeCampusName: null,
    activeCampusSlug: null,
};

const MetaSlice = createSlice({
    name: 'meta',
    initialState,
    reducers: {
        setActiveCampusId(state, action) {
            state.activeCampusId = action.payload;
        },
        // addCredits(state, action) {
        //     state.totalCredits += action.payload;
        // },
        // deductCredits(state, action) {
        //     state.totalCredits -= action.payload;
        // },

    },
});

export const { setActiveCampusId} = MetaSlice.actions;

export default MetaSlice.reducer;
